import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';
import { breakpoints } from '~/theme';

export const Section = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '66%, 1fr',
    gap: theme.space[3],
}));

export const Header = styled.div(({ theme }) => ({
    flexGrow: 1,
    gridColumn: '1 / 2',
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.space[2],
}));

export const Footer = styled.div((props) => ({
    position: 'relative',
    gridColumn: '1 / 3',
}));

export const SearchContainer = styled.div(() => ({
    flexGrow: 1,
    maxWidth: 280,
}));

export const Filter = styled.div((props) => ({
    position: 'relative',
    alignSelf: 'start',
    button: { width: 120 },
}));

export const DownloadDocuments = styled.div(() => ({
    gridRow: '3/4',
    maxWidth: 160,
    alignSelf: 'end',
    justifySelf: 'start',

    [breakpoints.md]: {
        gridRow: 'auto',
        alignSelf: 'start',
        justifySelf: 'end',
    },
}));

export const StyledTable = styled.div(() => ({
    gridColumn: '1 / 3',
}));

export const TableContainer = styled.div((props) => ({
    overflowX: 'scroll',
    '::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const TableCellLink = styled(Link)(({ theme }) => ({
    '--svg-width': theme.space[4],
    color: theme.colors.brandBlue,
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
    //don't break the text
    whiteSpace: 'nowrap',
    position: 'relative',
    textAlign: 'left',
    span: {
        span: {
            marginLeft: '0px',
        },
    },

    svg: {
        width: 'var(--svg-width)',
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        right: 'var(--svg-width)',
        bottom: 2,
        height: '1px',
        width: 'calc(100% - var(--svg-width))',
        backgroundColor: theme.colors.brandBlue,
    },
    '&:hover:after, &:active:after, &:focus:after': {
        width: '0%',
        transition: 'width 0.3s ease-in-out',
    },
    '&:hover, &:active, &:focus': {
        textDecoration: 'none',
    },
}));

export const StyledTableHeader = styled.button(({ theme }) => ({
    '&.my-specific-class': {
        color: theme.colors.brandBlue,
        textDecoration: 'underline',
        fontSize: theme.fontSizes.guinea,
        fontWeight: theme.fontWeights.medium,
        textAlign: 'left',
        whiteSpace: 'nowrap',
    },
}));

export const PageSetter = styled.div(({ theme }) => ({
    display: 'none',
    [breakpoints.md]: {
        height: '100%',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: theme.space[1],
    },
}));

export const Pagination = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.space[6],
}));

export const SkeletonSpacer = styled.div(() => ({
    height: 2,
}));

export const FilterWrapper = styled.div(() => ({
    gridColumn: '1 / 3',
    gridRow: '4 / 5',

    [breakpoints.md]: {
        gridRow: '3 / 4',
    },
}));
